export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const assetUrl = (path) =>
  path && path.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export { ARTIST } from "@/lib/site";
export { ENQUIRY_TYPES } from "@/content/chapters";

export const PORTFOLIO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/portfolio.pdf`;

// Portrait, hero and logo are served by the backend so Studio uploads reach the live site.
export const siteImg = (p) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/uploads/${p.split("/").pop()}?v=${typeof window !== "undefined" ? localStorage.getItem("pk_site_v") || "1" : "1"}`;

export const THEMES = [
  "Gods & Goddesses",
  "Nature",
  "Mythology",
  "Festivals",
  "Folk Life",
  "Contemporary Mithila",
];

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
